import { render } from "./MdTextarea.vue?vue&type=template&id=43079b45&scoped=true"
import script from "./MdTextarea.vue?vue&type=script&lang=js"
export * from "./MdTextarea.vue?vue&type=script&lang=js"

import "./MdTextarea.vue?vue&type=style&index=0&id=43079b45&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43079b45"],['__file',"src/components/mdbvue/Forms/MdTextarea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43079b45"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43079b45', __exports__)) {
    api.reload('43079b45', __exports__)
  }
  
  module.hot.accept("./MdTextarea.vue?vue&type=template&id=43079b45&scoped=true", () => {
    api.rerender('43079b45', render)
  })

}


export default __exports__